module.exports = __webpack_public_path__ + "img/partner4.e433c6c3.png";